import { CertificatePaymentModeEnum } from '@share/common-types';

import type { PaymentFormValues } from '../types';

export function resolveCertificatePaymentMode(
  values: Pick<PaymentFormValues, 'paymentPlan' | 'splitPayInFull' | 'splitInstalmentDown'>,
): CertificatePaymentModeEnum {
  if (values.paymentPlan === 'full') {
    return values.splitPayInFull
      ? CertificatePaymentModeEnum.PayInFullSplit
      : CertificatePaymentModeEnum.PayInFull;
  }
  return values.splitInstalmentDown
    ? CertificatePaymentModeEnum.InstalmentsSplitDownPayment
    : CertificatePaymentModeEnum.Instalments;
}
